<template>
  <v-layout row wrap>
    <v-flex xs12 py-3>
      <v-divider></v-divider>
    </v-flex>
    <v-flex>
      <v-layout row>
        <v-flex xs10 sm6 md4 lg3>
          <v-select :items="translatedRecipients" :value="email.recipients"
                    :label="$t('admin.alerts.email.editor.send_label')"
                    multiple chips
                    deletable-chips @change="updateRecipients"/>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-flex>
        <h3>{{$t('admin.alerts.email.editor.email')}}
          <v-menu offset-x offset-y nudge-left top :close-on-content-click="false" :close-on-click="true"
                  v-model="placeholderMenu">
            <v-btn icon slot="activator" class="hidden-md-and-up" @click="placeholderInfoClicked">
              <v-icon>info_outline</v-icon>
            </v-btn>
            <v-card>
              <v-container>
                <v-list>
                  <v-list-tile-content>
                    <v-list-tile-title class="custom-list-title custom-list-tile">
                      <h2>{{$t('admin.alerts.placeholders.title')}}</h2>
                    </v-list-tile-title>
                    <div class="my-2"></div>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{ID} - {{$t('admin.alerts.placeholders.student_id')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{FIRST_NAME} - {{$t('admin.alerts.placeholders.first_name')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{LAST_NAME} - {{$t('admin.alerts.placeholders.last_name')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{LINK_TO_STUDENT_PAGE} - {{$t('admin.alerts.placeholders.link_to_student_page')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{TUTOR_FIRST_NAME} - {{$t('admin.alerts.placeholders.tutor_first_name')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{TUTOR_LAST_NAME} - {{$t('admin.alerts.placeholders.tutor_last_name')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{EMAIL} - {{$t('admin.alerts.placeholders.student_email')}}</span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title class="custom-list-tile">
                      <span>{ATTENDANCE_PERCENTAGE} - {{$t('admin.alerts.placeholders.attendance_percentage')}}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list>
              </v-container>
            </v-card>
          </v-menu>
        </h3>
      </v-flex>
    </v-flex>
    <v-flex md6 xs12>
      <v-text-field multi-line rows="8" :value="email.text" @input="updateEmailText" @keyup.ctrl.alt="insertPlaceholder">
      </v-text-field>
    </v-flex>
    <v-flex md6 v-if="$vuetify.breakpoint.mdAndUp">
      <v-card class="custom-card elevation-3">
        <v-container>
          <v-list>
            <v-list-tile-content>
              <v-list-tile-title>
                <h2>{{$t('admin.alerts.placeholders.title')}}</h2>
              </v-list-tile-title>
              <div class="my-2"></div>
              <v-list-tile-sub-title>
                <span>{STUDENT_IDENTIFIER} - {{$t('admin.alerts.placeholders.student_id')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{FIRST_NAME} - {{$t('admin.alerts.placeholders.first_name')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{LAST_NAME} - {{$t('admin.alerts.placeholders.last_name')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{LINK_TO_STUDENT_PAGE} - {{$t('admin.alerts.placeholders.link_to_student_page')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{TUTOR_FIRST_NAME} - {{$t('admin.alerts.placeholders.tutor_first_name')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{TUTOR_LAST_NAME} - {{$t('admin.alerts.placeholders.tutor_last_name')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{EMAIL} - {{$t('admin.alerts.placeholders.student_email')}}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span>{ATTENDANCE_PERCENTAGE} - {{$t('admin.alerts.placeholders.attendance_percentage')}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-btn color="error" @click="deleteEmail({emailId: email.id, toBeDeleted: true})">
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn :disabled="!email.isEdited" @click="saveEmail(email.id)">
        <v-icon>save</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12>
      <email-previewer :email-message="email.text" :slider-values="sliderValues" :days="days"
                       :replacement-words="replacementWords">
      </email-previewer>
    </v-flex>
  </v-layout>
</template>

<script>
  import EmailPreviewer from './EmailPreviewer'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import {
    SET_ADMIN_ALERT_EMAIL_EDITED_STATE,
    UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS,
    UPDATE_ADMIN_ALERT_EMAIL_TEXT
  } from '../../../store/mutation-types'
  import { DELETE_ADMIN_ALERT_EMAIL, SAVE_ADMIN_ALERT_EMAIL } from '../../../store/action-types'
  import Helpers from '../../../mixins/Helpers'

  export default {
    components: {EmailPreviewer},
    name: 'email-editor',
    props: {
      sliderValues: {
        type: Array,
        required: true
      },
      days: {
        required: true
      },
      email: {
        type: Object,
        required: true
      }
    },
    mixins: [Helpers],
    data () {
      return {
        recipients: [
          {
            text: 'admin.alerts.recipients.student',
            value: 'STUDENT'
          },
          {
            text: 'admin.alerts.recipients.tutor',
            value: 'STAFF'
          }
        ],
        placeholderMenu: false
      }
    },
    methods: {
      updateRecipients (recipients) {
        this.setEmailEditedState({emailId: this.email.id, edited: true})
        this.setRecipients({recipients: recipients, id: this.email.id})
      },
      updateEmailText (text) {
        this.setEmailEditedState({emailId: this.email.id, edited: true})
        this.setEmailText({text: text, id: this.email.id})
      },
      insertPlaceholder (keyboardEvent) {
        switch (keyboardEvent.code) {
          case 'KeyF':
            this.updateEmailText(this.email.text + '{FIRST_NAME}')
            break
          case 'KeyL':
            this.updateEmailText(this.email.text + '{LAST_NAME}')
            break
        }
      },
      placeholderInfoClicked () {
        this.placeholderMenu = !this.placeholderMenu
      },
      ...mapMutations({
        setRecipients: UPDATE_ADMIN_ALERT_EMAIL_RECIPIENTS,
        setEmailText: UPDATE_ADMIN_ALERT_EMAIL_TEXT,
        setEmailEditedState: SET_ADMIN_ALERT_EMAIL_EDITED_STATE
      }),
      ...mapActions({
        saveEmail: SAVE_ADMIN_ALERT_EMAIL,
        deleteEmail: DELETE_ADMIN_ALERT_EMAIL
      })
    },
    computed: {
      replacementWords () {
        return {
          FIRST_NAME: 'John',
          LAST_NAME: 'Smith',
          STUDENT_IDENTIFIER: 147,
          LINK_TO_STUDENT_PAGE: `<a href="${this.baseUrl}/student/147">${this.baseUrl}/student/147</a>`,
          TUTOR_FIRST_NAME: 'Albert',
          TUTOR_LAST_NAME: 'Einstein',
          EMAIL: 'john.smith@myuni.com',
          ATTENDANCE_PERCENTAGE: '99%'
        }
      },
      translatedRecipients () {
        return this.translateFields(this.recipients)
      },
      ...mapState({
        baseUrl: state => state.config.baseUrl
      })
    }
  }
</script>

<style scoped>
  .custom-card {
    margin: -30px 0 0 20px;
  }

  .custom-list-tile {
    white-space: normal;
  }

  /* Mobile xs */
  @media (max-width: 320px) {
    .custom-list-title {
      height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/EmailEditor.vue